module.exports = __webpack_public_path__ + "static/media/ic_wallet_b2_myway.f1916fcc.svg";